module.exports = __webpack_public_path__ + "43060a9542c894ed52d8da23de932712.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/news-center/images/bg.png
// module id = 926
// module chunks = 3